import { v4 as uuidv4 } from 'uuid';

import { FlexLayoutCol, FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { Menu } from '../../../../vtex-apps/menu/Menu/default';
import { MenuItem } from '../../../../vtex-apps/menu/MenuItem/default';
import { RichText } from '../../../../vtex-apps/rich-text/RichText/default';
import { Image } from '../../../../vtex-apps/store-components/Image/default';
import { NewsletterInputEmail } from '../../../../vtex-apps/store-newsletter/NewsletterInputEmail/default';
import { NewsletterSubmit } from '../../../../vtex-apps/store-newsletter/NewsletterSubmit/default';
import { StoreImageList } from '../../../../vtex-apps/store-image-list/StoreImageList/default';
import { ListContextRenderer } from '../../../../vtex-apps/list-context/ListContextRenderer/default';
import { NewsletterForm as Newsletter } from '../../../../vtex-apps/store-newsletter/NewsletterForm/default';
import { VisibilityLayout } from '../../../../vtex-apps/VisibilityLayout/default';

export default function FooterDesktop() {
	return {
		componentName: 'FooterDesktop',
		componentId: uuidv4(),
		componentGroup: 'FooterDesktop',
		props: {
			mzTitle: 'MZ | Footer - Desktop',
			blockClass: 'footer-desktop-1',
		},
		variables,
		childrenComponents: [
			FlexLayoutRow({ blockClass: 'footer-desk-1-row-wrapper' }, [
				FlexLayoutRow(
					{
						blockClass: 'footer-desktop-1-newsletter',
						colSizing: 'auto',
						horizontalAlign: 'between',
					},
					[
						Image({
							src: 'https://hefesto-upload-images.s3.amazonaws.com/1683046479085-JdNwrJt.png',
						}),
						Newsletter(
							{
								blockClass: 'footer-desktop-1-newsletter',
								SuccessState: FlexLayoutRow(
									{
										blockClass: 'footer-desktop-1-newsletter__form',
									},
									[
										RichText({
											mzTitle: 'MZ | Mensagem de sucesso',
											text: 'Em breve, você receberá em seu e-mail nossas ofertas e descontos exclusivos!',
											blockClass: 'footer-deskt-1-rich-text__ns-success',
										}),
									],
								),
								ErrorState: FlexLayoutRow(
									{
										blockClass: 'footer-desktop-1-newsletter__form',
									},
									[
										RichText({
											mzTitle: 'MZ | Mensagem de erro',
											text: 'Ops, algo deu errado. :( Tente novamente mais tarde.',
											blockClass: 'footer-desk-1-newsletter__error',
										}),
									],
								),
							},
							[
								FlexLayoutRow(
									{
										colSizing: 'auto',
										blockClass: 'footer-desktop-1-newsletter__form',
									},
									[
										RichText({
											text: 'Receba descontos e novidades no seu e-mail',
											blockClass: 'footer-desktop-1-newsletter',
										}),
										NewsletterInputEmail({
											blockClass: 'footer-desktop-1-newsletter',
											placeholderText: 'Informe seu e-mail',
										}),
										NewsletterSubmit({
											submitButtonLabel: 'Cadastrar',
											blockClass: 'footer-desktop-1-newsletter',
										}),
									],
								),
							],
						),
					],
				),
				FlexLayoutRow(
					{
						blockClass: 'footer-desktop-1-content',
						colSizing: 'auto',
					},
					[
						VisibilityLayout({ mzTitle: 'MZ | Footer Coluna SEO' }, [
							FlexLayoutCol({}, [
								RichText({
									text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Malesuada quis sit massa rutrum vestibulum. Consequat neque, sit mattis rutrum ullamcorper in lectus adipiscing. ',
									blockClass: 'footer-desktop-1-alt__text',
								}),
								RichText({
									text: '[Loja](/about)',
									blockClass: 'footer-desktop-1-alt__link',
									textAlignment: 'left',
									textPosition: 'left',
								}),
							]),
						]),
						VisibilityLayout({ mzTitle: 'MZ | Footer Menu Loja' }, [
							FlexLayoutCol({}, [
								Menu({
									blockClass: 'footer-desktop-1-content__menu-item',
									orientation: 'vertical',
									items: [
										MenuItem({
											type: 'custom',
											highlight: true,
											itemProps: { type: 'internal', href: '/#', text: 'A [nome loja]' },
										}).props,
										MenuItem({
											type: 'custom',
											itemProps: { type: 'internal', href: '/#', text: 'Quem Somos' },
										}).props,
										MenuItem({
											type: 'custom',
											itemProps: { type: 'internal', href: '/#', text: 'Nossas Lojas' },
										}).props,
										MenuItem({
											type: 'custom',
											itemProps: { type: 'internal', href: '/#', text: 'Trabalhe Conosco' },
										}).props,
										MenuItem({
											type: 'custom',
											itemProps: { type: 'internal', href: '/#', text: 'Seja Revendedor' },
										}).props,
									],
								}),
							]),
						]),
						VisibilityLayout({ mzTitle: 'MZ | Footer Menu Política e Ajuda' }, [
							FlexLayoutCol({}, [
								Menu({
									blockClass: 'footer-desktop-1-content__menu-item',
									orientation: 'vertical',
									items: [
										MenuItem({
											type: 'custom',
											highlight: true,
											itemProps: { type: 'internal', href: '/#', text: 'Política e Ajuda' },
										}).props,
										MenuItem({
											type: 'custom',
											itemProps: {
												type: 'internal',
												href: '/#',
												text: 'Como comprar no nosso site',
											},
										}).props,
										MenuItem({
											type: 'custom',
											itemProps: {
												type: 'internal',
												href: '/#',
												text: 'Formas de Compra e Entrega',
											},
										}).props,
										MenuItem({
											type: 'custom',
											itemProps: {
												type: 'internal',
												href: '/#',
												text: 'Política de Troca e Devolução',
											},
										}).props,
										MenuItem({
											type: 'custom',
											itemProps: {
												type: 'internal',
												href: '/#',
												text: 'Política de Privacidade LGPD',
											},
										}).props,
										MenuItem({
											type: 'custom',
											itemProps: { type: 'internal', href: '/#', text: 'Fale Conosco' },
										}).props,
									],
								}),
							]),
						]),
						VisibilityLayout({ mzTitle: 'MZ | Footer Menu Sua Conta' }, [
							FlexLayoutCol({}, [
								Menu({
									blockClass: 'footer-desktop-1-content__menu-item',
									orientation: 'vertical',
									items: [
										MenuItem({
											type: 'custom',
											highlight: true,
											itemProps: { type: 'internal', href: '/#', text: 'Sua Conta' },
										}).props,
										MenuItem({
											type: 'custom',
											itemProps: { type: 'internal', href: '/#', text: 'Minha Conta' },
										}).props,
										MenuItem({
											type: 'custom',
											itemProps: { type: 'internal', href: '/#', text: 'Meus Pedidos' },
										}).props,
										MenuItem({
											type: 'custom',
											itemProps: { type: 'internal', href: '/#', text: 'Meus Favoritos' },
										}).props,
										MenuItem({
											type: 'custom',
											itemProps: { type: 'internal', href: '/#', text: 'Notificação por email' },
										}).props,
										MenuItem({
											type: 'custom',
											itemProps: { type: 'internal', href: '/#', text: 'Notificação por email' },
										}).props,
									],
								}),
							]),
						]),
						VisibilityLayout({ mzTitle: 'MZ | Footer Atendimento' }, [
							FlexLayoutCol(
								{
									blockClass: 'footer-desktop-1-content__col',
								},
								[
									FlexLayoutCol({}, [
										RichText({
											text: '**Atendimento**',
											blockClass: 'footer-desktop-1-content__title',
											textAlignment: 'left',
											textPosition: 'left',
										}),
										RichText({
											text: 'De segunda a sexta, das 9h as 18h.',
											blockClass: 'footer-desktop-1-content__atendimento',
											textAlignment: 'left',
											textPosition: 'left',
										}),
										RichText({
											text: 'Telefones: **(00) 0000-0000 / (00) 0 0000-0000**',
											blockClass: 'footer-desktop-1-content__atendimento',
											textAlignment: 'left',
											textPosition: 'left',
										}),
										RichText({
											text: 'E-mail: [contato@nomeloja.com.br](mailto:contato@nomeloja.com.br)',
											blockClass: 'footer-desktop-1-content__atendimento',
											textAlignment: 'left',
											textPosition: 'left',
										}),
									]),
									FlexLayoutCol({}, [
										RichText({
											text: '**Nossas Redes Sociais**',
											textAlignment: 'left',
											textPosition: 'left',
											blockClass: 'footer-desktop-1-content__title',
										}),
										FlexLayoutRow(
											{
												horizontalAlign: 'left',
												colSizing: 'auto',
												blockClass: 'footer-desktop-1-social-icons',
											},
											[
												StoreImageList(
													{
														height: 12,
														images: [
															{
																alt: 'Facebook',
																src: 'https://hefesto-upload-images.s3.amazonaws.com/1683046717711-212365083-5b98cc81-5847-402a-9ab8-290df2ccb242.png',
																link: {
																	url: 'https://www.facebook.com/',
																	newTab: true,
																},
																blockClass: 'footer-desktop-1-social-icons__list',
															},
															{
																alt: 'Instagram',
																src: 'https://hefesto-upload-images.s3.amazonaws.com/1683046730547-212365091-d67ff0ac-e491-4e2b-bee6-087f6eb20031.png',
																link: {
																	url: 'https://www.instagram.com/',
																	newTab: true,
																},
																blockClass: 'footer-desktop-1-social-icons__list',
															},
															{
																alt: 'Twitter',
																src: 'https://hefesto-upload-images.s3.amazonaws.com/1683046743459-212365094-c5cd4039-4f34-42e6-9115-e6c034297413.png',
																link: {
																	url: 'https://twitter.com/',
																	newTab: true,
																},
																blockClass: 'footer-desktop-1-social-icons__list',
															},
															{
																alt: 'TikTok',
																src: 'https://hefesto-upload-images.s3.amazonaws.com/1693331955678-tiktok.png',
																link: {
																	url: 'https://tiktok.com/',
																	newTab: true,
																},
																blockClass: 'footer-desktop-1-social-icons__list',
															},
														],
													},
													[
														ListContextRenderer({
															blockClass: 'footer-desktop-1-social-icons__list',
															listElement: 'ul',
															itemElement: 'li',
														}),
													],
												),
											],
										),
									]),
								],
							),
						]),
					],
				),
			]),
			FlexLayoutRow(
				{
					blockClass: 'footer-desktop-1-seals',
				},
				[
					VisibilityLayout({ mzTitle: 'MZ | Footer Pagamentos' }, [
						FlexLayoutCol({}, [
							RichText({
								text: '**Formas de pagamento e bandeiras aceitas**',
								blockClass: 'footer-desktop-1-seal__title',
								textAlignment: 'left',
								textPosition: 'left',
							}),
							FlexLayoutRow(
								{
									colSizing: 'auto',
									blockClass: 'footer-desktop-1-payment-logo',
									horizontalAlign: 'left',
								},
								[
									StoreImageList(
										{
											height: 36,
											images: [
												{
													src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166279-payment-system-mastercard.png',
													alt: 'MasterCard',
													title: 'MasterCard',
												},
												{
													src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166279-payment-system-visa.png',
													alt: 'Visa',
													title: 'Visa',
												},
												{
													src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166278-payment-system-hipercard.png',
													alt: 'Hipercard',
													title: 'Hipercard',
												},
												{
													src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166278-payment-system-hiper.png',
													alt: 'Hiper',
													title: 'Hiper',
												},
												{
													src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166277-payment-system-dinersclub.png',
													alt: 'Diners Club',
													title: 'Diners Club',
												},
												{
													src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166279-payment-system-jcb.png',
													alt: 'JCB',
													title: 'JCB',
												},
												{
													src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166277-payment-system-discover.png',
													alt: 'Discover',
													title: 'Discover',
												},
												{
													src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166278-payment-system-elo.png',
													alt: 'Elo',
													title: 'Elo',
												},
												{
													src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166277-payment-system-boleto.png',
													alt: 'Boleto',
													title: 'Boleto',
												},
												{
													src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166279-payment-system-pix.png',
													alt: 'Pix',
													title: 'Pix',
												},
											],
										},
										[
											ListContextRenderer({
												blockClass: 'footer-desktop-1-payment__list',
												listElement: 'ul',
												itemElement: 'li',
											}),
										],
									),
								],
							),
						]),
					]),
					VisibilityLayout({ mzTitle: 'MZ | Footer Selos de Segurança' }, [
						FlexLayoutCol({}, [
							RichText({
								text: '**Selos de segurança**',
								blockClass: 'footer-desktop-1-seal__title',
								textAlignment: 'left',
								textPosition: 'left',
							}),
							FlexLayoutRow(
								{
									blockClass: 'footer-desktop-1--high',
									colSizing: 'auto',
									horizontalAlign: 'left',
								},
								[
									StoreImageList(
										{
											height: 55,
											images: [
												{
													src: 'https://hefesto-upload-images.s3.amazonaws.com/1676318216942-eureciclo.png',
													alt: 'Eureciclo',
													title: 'SeloEu Reciclo',
													link: {
														url: '',
													},
												},
												{
													src: 'https://hefesto-upload-images.s3.amazonaws.com/1676318175602-ebit.png',
													alt: 'Ebit',
													title: 'Selo Ebit',
													link: {
														url: '',
													},
												},
												{
													src: 'https://hefesto-upload-images.s3.amazonaws.com/1676318302329-lets-encrypt.png',
													alt: 'Let`s Encript',
													title: 'Selo Let`s Encript',
													link: {
														url: '',
													},
												},
											],
										},
										[
											ListContextRenderer({
												blockClass: 'footer-desktop-1-payment__flags',
												listElement: 'ul',
												itemElement: 'li',
											}),
										],
									),
								],
							),
						]),
					]),
					FlexLayoutCol({}, [
						FlexLayoutRow(
							{
								blockClass: 'footer-desktop-1-powered',
								colGap: 2,
							},
							[
								FlexLayoutCol({ width: 'auto' }, [
									RichText({
										text: '**Powered by**',
										blockClass: 'footer-desktop-1-powered-title',
										textAlignment: 'left',
										textPosition: 'left',
									}),
									Image({
										src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166277-logo-checkout-vtex.png',
										title: 'VTEX',
										link: {
											url: 'https://vtex.com/',
											openNewTab: true,
										},
										blockClass: 'footer-desktop-1',
									}),
								]),
								FlexLayoutCol({ width: 'auto' }, [
									RichText({
										text: '**Desenvolvido por**',
										blockClass: 'footer-desktop-1-powered-title',
										textAlignment: 'left',
										textPosition: 'left',
									}),
									Image({
										src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166276-logo-checkout-maeztra.png',
										title: 'Maeztra',
										link: {
											url: 'https://maeztra.com/',
											openNewTab: true,
										},
										blockClass: 'footer-desktop-1',
									}),
								]),
							],
						),
					]),
				],
			),
			FlexLayoutRow(
				{
					blockClass: 'footer-desktop-1-legal-info',
					horizontalAlign: 'center',
					colSizing: 'auto',
				},
				[
					RichText({
						text: '[NOME EMPRESA] LTDA - CNPJ: 00.000.000/0001-00 [RUA OU AVENIDA], 000 - [BAIRRO], [CIDADE] - [UF], CEP 00000-000',
						blockClass: 'footer-desktop-1-legal-text',
					}),
				],
			),
		],
	};
}

const variables = [
	{
		type: 'color',
		list: [
			{
				from: '--white',
				to: '--footer-desktop-1-background',
				name: 'Background Color',
			},
			{
				from: '--brand-color-primary-pure',
				to: '--footer-desktop-1-seals-background',
				name: 'Seals Background Color',
			},
			{
				from: '--brand-color-primary-pure',
				to: '--footer-desktop-1-heading-color',
				name: 'Heading Color',
			},
			{
				from: '--brand-color-secondary-pure',
				to: '--footer-desktop-1-main-color',
				name: 'Main Color',
			},
			{
				from: '--brand-color-primary-light',
				to: '--footer-desktop-1-hover-color',
				name: 'Hover Color',
			},
			{
				from: '--text-color-1',
				to: '--footer-desktop-1-legal-text-color',
				name: 'Legal text color',
			},
			{
				from: '--white',
				to: '--footer-desktop-1-seal-title-color',
				name: 'Seal Title color',
			},
			{
				from: '--brand-color-secondary-pure',
				to: '--footer-desktop-1-social-color',
				name: 'Social Media Color',
			},
		],
	},
	{
		type: 'fontSize',
		list: [
			{
				from: '--font-size-sm',
				to: '--footer-desktop-1-main-size',
				name: 'Main font Size',
			},
		],
	},
	{
		type: 'spacing',
		list: [{ from: '--spacing-atom', to: '--footer-1-social-spacing', name: 'Social Media padding' }],
	},
	{
		type: 'borderRadius',
		list: [{ from: 0, to: '--footer-1-social-radius', name: 'Social Media Border Radius' }],
	},
];
